import { render } from "./addModule.vue?vue&type=template&id=40e9bc2a&scoped=true"
import script from "./addModule.vue?vue&type=script&lang=js"
export * from "./addModule.vue?vue&type=script&lang=js"

import "./addModule.vue?vue&type=style&index=0&id=40e9bc2a&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e9bc2a"]])

export default __exports__